module.exports = __webpack_public_path__ + "img/ATTRIBUTES.1cadb0a9.svg";